import React from 'react'
import Workout from './WorkoutComponent.js'

export default class AdminWorkout extends React.Component {
  constructor (props) {
    console.log(props)
    super(props)
    this.state = {
      props: props
    }
  }

  render = () => {
    return (<Workout {...this.state.props} isAdmin={true} />)
  }
}
